import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import { ElementDefinition, NavbarElement } from "@easy-email-pro-core/typings";
import React from "react";
import { BasicBlock } from "@easy-email-pro-core/components";

const defaultData: ElementDefinition<NavbarElement>["defaultData"] = {
  attributes: {
    align: "center",
    "base-url": null,
    hamburger: null,
    "ico-align": "center",
    "ico-open": "&#9776;",
    "ico-close": "&#8855;",
    "ico-color": "#000000",
    "ico-font-size": "30px",
    "ico-font-family": "Arial",
    "ico-text-transform": "uppercase",
    "ico-padding": "10px",
    "ico-text-decoration": "none",
    "ico-line-height": "30px",
    "padding-top": "0px",
    "padding-right": "0px",
    "padding-bottom": "0px",
    "padding-left": "0px",
  },
  data: {},
};

export const Navbar = createBlock<NavbarElement>({
  get name() {
    return t("Navbar");
  },
  defaultData,
  type: BasicType.NAVBAR,
  create: (payload) => {
    const defaultData: NavbarElement = {
      type: BasicType.NAVBAR,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.NAVBAR,
  render(params) {
    return <BasicBlock params={params} tag="mj-navbar" />;
  },
});
